import styles from './FormInput.module.css';

function FormInput({label, width, required, children}) {
    return (
        <div className={styles.container} style={{width: width}}>
            <label className={required ? `required-field ${styles.inputLabel}` : styles.inputLabel}>{label}</label>
            {children}
        </div>
    )
}

export default FormInput;